import React, { ReactNode } from 'react';
import { Theme } from '../../coreModules/coreFiles/types';
import './Heading.scss';

type HeadingSize = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'h7' | 'H1'
type HeadingType = 'primary' | 'secondary' | 'tertiary';

interface HeadingProps {
  children: ReactNode;
  size?: HeadingSize;
  type?: HeadingType;
  style?: React.CSSProperties;
  className?: string;
  theme?: Theme;
  cursor?: string;
  secondaryTextColor?: string;
  secondaryText?: string;
  [key: string]: any;
}

const Heading: React.FC<HeadingProps> = ({
  children,
  size = 'h1',
  type = 'primary',
  style = {},
  className = '',
  theme = 'light',
  secondaryTextColor = '#000000',
  secondaryText = '',
  cursor = 'default',
  ...restProps
}) => {
  // Build class names based on props
  const headingClasses = [
    'ap-heading',
    `ap-heading--${size}`,
    `ap-heading--${type}`,
    `ap-heading--${theme}`,
    cursor !== 'default' ? `ap-heading--cursor-${cursor}` : '',
    className
  ].filter(Boolean).join(' ');

  const secondaryTextClasses = [
    'ap-heading__secondary-text',
    `ap-heading__secondary-text--${size}`
  ].join(' ');

  return (
    <div 
      className={headingClasses} 
      style={style} 
      {...restProps}
    >
      <span>
      {children}
      </span>
      {secondaryText && (
        <span 
          className={secondaryTextClasses} 
          style={{ color: secondaryTextColor }}
        >
          {secondaryText}
        </span>
      )}
    </div>
  );
};

export default Heading;